import styled from 'styled-components';
export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100000;

  opacity: 1;
  animation: modalBounce 0.15s ease-in-out;

  @keyframes modalBounce {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: calc(100% - 40px);
  height: fit-content;

  background-color: ${({ theme }) => theme.palette.white};
  transform: translate(-50%, -50%);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
  transition: all 0.3s;
  z-index: 15;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  text-align: center;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 410px;
    height: auto;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  & button {
    height: 40px;
  }

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    & button {
      height: 55px;
    }
  }
`;

export const CloseIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
